import { SpecSheet } from "kinnect-models";
import { KActionDialog } from "kinnect-general";

export default {
	name: "SpecSheetDeleteDialog",

	props: {
		...KActionDialog.options.props,

		confirmButtonColor: {
			...KActionDialog.options.props.confirmButtonColor,
			default: "error"
		},

		confirmButtonText: {
			...KActionDialog.options.props.confirmButtonText,
			default: "Delete"
		},

		item: {
			required: true,
			type: SpecSheet
		},

		title: {
			...KActionDialog.options.props.title,
			default: "Delete Spec Sheet"
		}
	},

	render() {
		return <KActionDialog
			attrs={{
				...this.$props,
				loading: this.$wait.is( "delete spec sheet" )
			}}
			on={{ ...this.$listeners }}
			scopedSlots={{
				default: () => <div>Are you sure you want to delete this spec sheet?</div>,

				...this.$scopedSlots
			}}
		></KActionDialog>;
	}
};
